<script lang="ts">
	import { tokensAllowedForDepositUI } from '$lib/home/scwallet/config';
	import TokenBalanceRow from '$lib/home/scwallet/homeportfolio/TokenBalanceRow.svelte';
	import { smartContractWalletAddress, tokensInWalletUSD } from '$lib/home/scwallet/store';
	import { firstLoadedUserBalances, userBalancesEnriched } from '$lib/home/store';
	import type { TokenUI } from '$lib/types/tokens';
	import {
		addDollarSign,
		getDecimalOfToken,
		getNumBackInUnits,
		sortInDescending
	} from '$lib/util/util';

	let tokenInDescendingOrder: TokenUI[];
	$: if (
		$userBalancesEnriched &&
		$tokensAllowedForDepositUI &&
		Object.keys($userBalancesEnriched).length !== 0 &&
		$tokensAllowedForDepositUI.reduce((accumulator, token) => {
			return accumulator && $userBalancesEnriched[token.symbol] !== undefined;
		}, true)
	) {
		let tokensAllowedForDepositEnriched: Record<string, TokenUI> = {};

		$tokensAllowedForDepositUI.forEach((token) => {
			tokensAllowedForDepositEnriched[token.symbol] = {
				...$userBalancesEnriched[token.symbol],
				allowed: token.allowed,
				type: token.type
			};
			tokensAllowedForDepositEnriched[token.symbol].allowed = token.allowed;
		});

		tokenInDescendingOrder = sortInDescending(tokensAllowedForDepositEnriched) as TokenUI[];
	}
</script>

<div class="flex flex-col gap-1">
	<div class="flex justify-between items-center">
		<p class="text-fx-gradient-5 font-semibold text-lg">
			{#if $tokensInWalletUSD}
				{addDollarSign(getNumBackInUnits($tokensInWalletUSD.toString(), 18, 2))}
			{:else}
				<div>-</div>
			{/if}
		</p>
		<img
			loading="lazy"
			src={'new_sc_wallet/tokens.png'}
			alt="new_sc_wallet/tokens.png"
			class="w-[70px] h-[20px]"
		/>
	</div>
	<p class="text-fx-grey-300 text-sm font-regular">Wallet Balance</p>
</div>

<div class="border-t border-t-fx-grey-600 w-full my-4" />

<div class="flex flex-col gap-2 h-96 overflow-y-auto fx-scrollbar">
	{#if $firstLoadedUserBalances && tokenInDescendingOrder && tokenInDescendingOrder.length > 0}
		{#each tokenInDescendingOrder as token}
			<TokenBalanceRow
				{token}
				balance={getNumBackInUnits(token.balance, getDecimalOfToken(token.symbol), 2)}
				scwAddress={$smartContractWalletAddress}
				type={token.type}
			/>
		{/each}
	{:else if $firstLoadedUserBalances && tokenInDescendingOrder && tokenInDescendingOrder.length == 0}
		<div class="flex flex-col h-full">
			<img loading="lazy" src={'no-trades.webp'} alt="static/no-trades.webp" class="w-36" />
			<div class="text-fx-grey-300 text-xs mt-4">No Token Balances</div>
		</div>
	{:else}
		<div class="flex flex-col items-center w-full h-full justify-between">
			<div
				class="animate-pulse bg-fx-grey-800 h-12 col-span-2 rounded-lg squircle-lg mx-auto w-full"
			/>
			<div
				class="animate-pulse bg-fx-grey-800 h-12 col-span-2 rounded-lg squircle-lg mx-auto w-full"
			/>
			<div
				class="animate-pulse bg-fx-grey-800 h-12 col-span-2 rounded-lg squircle-lg mx-auto w-full"
			/>
			<div
				class="animate-pulse bg-fx-grey-800 h-12 col-span-2 rounded-lg squircle-lg mx-auto w-full"
			/>
			<div
				class="animate-pulse bg-fx-grey-800 h-12 col-span-2 rounded-lg squircle-lg mx-auto w-full"
			/>
			<div
				class="animate-pulse bg-fx-grey-800 h-12 col-span-2 rounded-lg squircle-lg mx-auto w-full"
			/>
		</div>
	{/if}
</div>
